import { ApiUtil as api } from "@/utils/api.util.js";

export class MaintenanceTaskService {

  static URL = process.env.API_URL + process.env.API_VER;
  static RESOURCE = "/maintenance-tasks/";

  static all(params = {}) {
    return api.get(this.URL + this.RESOURCE, params);
  }

  static listImportValues(params = {}) {
    return api.get(this.URL + this.RESOURCE + "import-values", params);
  }

  static import(data = {}, config = {}) {
    return api.post(this.URL + this.RESOURCE + "import", data, config);
  }

  static downloadImportTemplate(data = {}, config = {}) {
    return api.post(this.URL + this.RESOURCE + "download-import-template", data, config);
  }

  static generate(data = {}) {
    return api.post(this.URL + this.RESOURCE + "generate", data);
  }

  static generateUndo(data = {}) {
    return api.post(this.URL + this.RESOURCE + "generate_undo", data);
  }

  static generatedOrders(params = {}) {
    return api.get(this.URL + this.RESOURCE + "generated-orders", params);
  }

  static archive(id) {
    return api.post(this.URL + this.RESOURCE + id +  "/archive");
  }

  static restore(id) {
    return api.post(this.URL + this.RESOURCE + id + "/restore");
  }

}


// WEBPACK FOOTER //
// ./src/services/maintenanceTask.service.js